module.exports = __webpack_public_path__ + "img/logo-voomp.3caf2404.svg";